module.exports = __webpack_public_path__ + "assets/img/icon-6.2d80eeb6.png";